import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

@Injectable({
  providedIn: 'root'
})
export class FirebaseConfigService {
  
  getConfig(): FirebaseConfig {
    const fb = environment.firebase as Partial<FirebaseConfig>;
    if (
      !fb.apiKey ||
      !fb.authDomain ||
      !fb.projectId ||
      !fb.storageBucket ||
      !fb.messagingSenderId ||
      !fb.appId
    ) {
      throw new Error('Firebase environment is missing required keys');
    }
    return {
      apiKey: fb.apiKey,
      authDomain: fb.authDomain,
      projectId: fb.projectId,
      storageBucket: fb.storageBucket,
      messagingSenderId: fb.messagingSenderId,
      appId: fb.appId,
      measurementId: fb.measurementId ?? '',
      databaseURL:
        fb.databaseURL ?? `https://${fb.projectId}-default-rtdb.firebaseio.com`,
    };
  }

  // Alternative config for contact form (if needed)
  getContactConfig(): FirebaseConfig {
    return {
      apiKey: "AIzaSyCVen-dPBBhfDvfL-GS4HxlvuTu6Pqx0mI",
      authDomain: "servvic-93538.firebaseapp.com",
      databaseURL: "https://servvic-93538-default-rtdb.firebaseio.com",
      projectId: "servvic-93538",
      storageBucket: "servvic-93538.appspot.com",
      messagingSenderId: "1069351196691",
      appId: "1:1069351196691:web:dd6d3f1cc59180d4f907e6",
      measurementId: "G-VJNKE8M77X"
    };
  }
}
